import React, { useState } from 'react';
import { FaRegUser } from 'react-icons/fa';
import { IoCloseCircle } from 'react-icons/io5';
import LiveDashBoard from './liveDashBoard';
import LivePerformance from './livePerformance';

type TabType = 'dashboard' | 'performance';

interface LiveMonitorProps {
    isOpen: boolean;
    gameUuid: string | null;
    onClose: () => void;
}

const LiveMonitor: React.FC<LiveMonitorProps> = ({ isOpen, gameUuid, onClose }) => {
    const [activeTab, setActiveTab] = useState<TabType>('dashboard');

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-[#fcfcfc] w-[97vw] h-[97vh] rounded-xl shadow-2xl flex flex-col relative overflow-hidden">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-4 text-[#ff4d4f] hover:text-[#d9363e] transition cursor-pointer z-10 bg-white rounded-full flex items-center justify-center"
                >
                    <IoCloseCircle size={26} />
                </button>

                <div className="px-6 mt-12">
                    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                        <div className="flex flex-col gap-1">
                            <span className="text-base font-semibold text-gray-700">Live Monitor</span>
                            <h1 className="text-3xl font-semibold text-gray-900">ภาษาไทย ป.1</h1>
                        </div>

                        <hr className="my-2 border-gray-200" />

                        <div className="flex items-center text-base font-normal text-gray-800 gap-2">
                            <FaRegUser className="text-gray-600" />
                            <span className="pt-1">จำนวนนักเรียน: <strong className="text-black">32</strong></span>
                        </div>
                    </div>
                </div>

                <div className="flex px-6 mt-4">
                    <button
                        onClick={() => setActiveTab('dashboard')}
                        className={`w-[473px] py-2 rounded-t-xl font-semibold text-lg transition-colors duration-200 cursor-pointer ${activeTab === 'dashboard'
                            ? 'bg-[#FCE803] text-black'
                            : 'bg-[#EBEBEB] text-gray-500 hover:bg-[#e2e2e2]'
                            }`}
                    >
                        Live Dashboard
                    </button>
                    <button
                        onClick={() => setActiveTab('performance')}
                        className={`w-[473px] py-2 rounded-t-xl font-semibold text-lg transition-colors duration-200 cursor-pointer ${activeTab === 'performance'
                            ? 'bg-[#FCE803] text-black'
                            : 'bg-[#EBEBEB] text-gray-500 hover:bg-[#e2e2e2]'
                            }`}
                    >
                        Live Performance
                    </button>
                </div>

                <div className="flex-1 overflow-hidden px-6 pb-2">
                    <div className="h-full w-full overflow-y-auto overscroll-contain bg-white border border-gray-200 rounded-b-xl rounded-tr-xl shadow-sm">
                        {activeTab === 'dashboard' ? <LiveDashBoard gameUuid={gameUuid} /> : <LivePerformance />}
                    </div>
                </div>

                <div className="p-4 flex justify-center">
                    <button
                        onClick={onClose}
                        className="bg-[#f25252] hover:bg-[#d94a4a] text-white px-12 py-2 rounded-md font-medium transition duration-200 shadow-sm cursor-pointer"
                    >
                        ปิด
                    </button>
                </div>

            </div>
        </div>
    );
};

export default LiveMonitor;